import React, { forwardRef } from 'react';

const Input = forwardRef((props, ref) => (
  <input {...props} ref={ref} className="h-7 p-1 w-full border border-gray-300 rounded" />
));

export default Input;
